export const environment = {
  sentryDsn: 'https://c582730e257dcae3e7183ba80e88a72f@o4512168678195200.ingest.de.sentry.io/4512215163863120',
  sentryEnvironment: 'dev',
     base_url: 'https://trackmotor.dynamicwebsite.co.in/mindbase-dev/',
    // base_url : 'http://localhost:6001/',
    // multitenant to single tenant
     // slugVerifyUrl: 'https://trackmotor.dynamicwebsite.co.in/jp/mindbase/dev/prepbase-admin/admin-dev/',
  image_url: 'https://trackmotor.dynamicwebsite.co.in/mindbase-dev/admin/media/uploadFile',
  // multitenant to single tenant
  // slugVerifyUrl: '',
  socket_url: 'https://dev-socket.dynamicwebsite.co.in',
    // socket_url:'http://localhost:6002/',
    socket_path : '',
  rememberMeKey: 'MB_RM_SK_D',
  storageKey: 'MB_A_SK_D',
  refreshStorageKey: 'MB_A_SK_D_RT',
  refreshTokenIntervalMs: 30 * 60 * 1000, // 30 min proactive refresh — well within the 5h access token lifetime
  googleApiKey: '',
  firebaseConfig: {
    apiKey: 'AIzaSyA74yJXmt34C2E_yyTQOgwMlH12O90rS9w',
    authDomain: 'prepbase-76b91.firebaseapp.com',
    projectId: 'prepbase-76b91',
    storageBucket: 'prepbase-76b91.firebasestorage.app',
    messagingSenderId: '181364161362',
    appId: '1:181364161362:web:67ce0863d646f91c81d88b',
    measurementId: 'G-D9P45VNQLT',
    vapidKey:
      'BAeAjs2pkYIY9TwQfEw6394Sf1-drYjtBpqmXfxj38au1sEkS-TWxUQ35lgn2AI5XlMBshcUjY6snJIAyR1mnCw'
  },
  stripePublicKey:
    'pk_test_51Qpp54E9dCHbiXJV6Okor1RpLgwCLKDTvIIOq7SFdVfU7Q1UyuoVFactBrmrdqCe1ZYcx4gh53KIZjJDh4522teq00jWleYgRa'
  // stripePublicKey: 'pk_test_51PAmx5SJeoR7HKHV49ccTs0DjSSq80TM02hL3cod6XXDUIUMVoQtAR5cDLlhUnPNMZGqHhrZSTegrsq5sM9o2D5F00TIUAKLt1'
};
